import { createContext } from "react";
const DeliverySlotContext = createContext({});

export default DeliverySlotContext;
